import * as React from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import ButtonView from "../common/button/ButtonView";
import styled from "@emotion/styled";
import { FormControl } from "@mui/material";
import {
  CLOSE_WINDOW_BTN,
  CLOSE_WINDOW_LABEL,
  COLOR_WHITE,
  COMPITATOE_HEADER,
  COMPITATOE_ROW,
  INTERCHANGE_HEAD_STYLE,
  LOADING,
  MIN_WIDTH_500,
} from "../../utils/GlobalConstants";
import { COMPITATOR_NO_RECORDS } from "../../utils/GlobalMessageConstants";
import { INTERCHANGE_HEADER_DATA } from "../../utils/GlobalFormConstants";
import { partDetails } from "../../services/SurveyRequest";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "rgb(229, 231, 243)",
    paddingLeft: 5,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    paddingLeft: 5,
  },
}));
function EnhancedTableHead(props) {
  return (
    <TableHead>
      <TableRow>
        {INTERCHANGE_HEADER_DATA.map((headCell) => (
          <StyledTableCell
            key={headCell.id}
            align={"center"}
            sx={COLOR_WHITE}
            style={COMPITATOE_HEADER}
          >
            {headCell.label}
          </StyledTableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

const CompetitorView = (props) => {
  const [rows, setrows] = React.useState([]);
  const [nodata, setnoData] = React.useState(false);
  const getInterchanges = React.useCallback(async () => {
    try {
      const response = await partDetails(props?.competitorPartNumber);
      const competitorPartDetails = [...response?.itemResponse?.items];
      const combinedItems = [];
      competitorPartDetails &&
        competitorPartDetails.forEach((item) => {
          item.interchangeInfo.interchangePartsInfos.forEach(
            (interchangeInfo) => {
              const combinedItem = {
                pid: item.pid,
                partType: item.title,
                partNumber: item.partNumber,
                brand: item.brand,
                id: interchangeInfo.id,
                compBrand: interchangeInfo.brand,
                compPartNum: interchangeInfo.partNum,
              };
              combinedItems.push(combinedItem);
            }
          );
        });
      setrows(combinedItems);
    } catch (e) {
      setnoData(true);
    }
  }, [props.competitorPartNumber]);

  React.useEffect(() => {
    getInterchanges();
  }, [getInterchanges]);

  const handleClick = (e, row) => {
    props.getDataFromComp(row);
    props.handleClose();
  };
  return (
    <Box>
      <Paper>
        <TableContainer>
          <Table sx={MIN_WIDTH_500} aria-labelledby="tableTitle">
            <EnhancedTableHead />
            {rows?.length > 0 ? (
              <TableBody>
                {rows.map((row, index) => {
                  return (
                    <TableRow
                      hover
                      testid="row"
                      tabIndex={-1}
                      key={row.id}
                      sx={COMPITATOE_ROW}
                      onClick={(event) => handleClick(event, row)}
                    >
                      <StyledTableCell
                        style={INTERCHANGE_HEAD_STYLE}
                        component="th"
                        scope="row"
                        padding="none"
                      >
                        {row.partNumber}
                      </StyledTableCell>
                      <StyledTableCell style={INTERCHANGE_HEAD_STYLE}>
                        {row.brand}
                      </StyledTableCell>
                      <StyledTableCell style={INTERCHANGE_HEAD_STYLE}>
                        {row.partType}
                      </StyledTableCell>
                      <StyledTableCell style={INTERCHANGE_HEAD_STYLE}>
                        {row.compPartNum}
                      </StyledTableCell>
                      <StyledTableCell style={INTERCHANGE_HEAD_STYLE}>
                        {row.compBrand}
                      </StyledTableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            ) : nodata ? (
              <div className="noRecordsInterchanges">
                {COMPITATOR_NO_RECORDS}
              </div>
            ) : (
              <div>{LOADING}</div>
            )}
          </Table>
        </TableContainer>
      </Paper>
      <Box sx={CLOSE_WINDOW_BTN}>
        <FormControl>
          <ButtonView
            testid="close"
            label={CLOSE_WINDOW_LABEL}
            onClick={() => {
              props.handleClose();
            }}
          ></ButtonView>
        </FormControl>
      </Box>
    </Box>
  );
};
export default CompetitorView;
